
export { AuthenticatedAPI } from "/builds/dd3tech/wiggot/wiggot-web/packages/core-apis/src/apis/config/api/authenticatedApi.ts"
export { HttpRequestService } from "/builds/dd3tech/wiggot/wiggot-web/packages/core-apis/src/apis/config/httpService.ts"